import ApiService from "../../utils/fetch";
const currencyConversionDetailUrl = `${process.env.REACT_APP_BASE_URL}currencyconversion/details`;

export const fetchCurrencyConversionDetailsData = async (id) => {
    const url = `${currencyConversionDetailUrl}?fromCurrency=${id}&toCurrency=USD`;
    const response = await ApiService.get(url);
    return response.data;
};
